// extracted by mini-css-extract-plugin
export default {"mobile-tip-content":"MqAQ8Li___mobile-tip-content","mobileTipContent":"MqAQ8Li___mobile-tip-content"};